<!-- //////////////////////////////////////////////////////////////////////////// -->
<!-- START Notification Sidebar -->
<aside #sidebar id="notification-sidebar" class="notification-sidebar d-none d-sm-none d-md-block">
  <a class="notification-sidebar-close" (click)="onClose()">
    <i class="ft-x font-medium-3"></i>
  </a>
  <div class="side-nav notification-sidebar-content pl-0">
    <!-- <div class="row">
      <div class="col-md-12">
        <h6>Filtros</h6>
      </div>
    </div> -->
    <form novalidate [formGroup]="filtersForm" class="form form-horizontal striped-rows mt-4" (ngSubmit)="applyFilters()">
      <div class="form-body">
        <div class="form-group row">
          <label class="col-md-3 label-control">Sector</label>
          <div class="col-md-9">
            <app-sector-filter [form]="sectorControls"
                               [sectors]="sectors"
                               (sectorSelected)="updateFormValue($event, 'idSector')"
                               *ngIf="sectorControls">
            </app-sector-filter>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Flujo</label>
          <div class="col-md-9">
            <app-flow-filter [form]="flowControls"
                             [flows]="flows"
                             (flowSelected)="updateFormValue($event, 'idFlow')"
                             *ngIf="flowControls">
            </app-flow-filter>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Desde</label>
          <div class="col-md-9">
            <input class="form-control" type="date" formControlName="dateFrom"
              [min]="ganttMinDate" [max]="filtersForm.get('dateTo').value || ganttMaxDate" />
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Hasta</label>
          <div class="col-md-9">
            <input class="form-control" type="date" formControlName="dateTo"
              [min]="filtersForm.get('dateFrom').value || ganttMinDate" [max]="ganttMaxDate" />
            <small class="form-text text-muted danger" *ngIf="filtersForm.hasError('dateRange')">
              La fecha "Hasta" no puede ser anterior a "Desde"
            </small>
            <small class="form-text text-muted danger" *ngIf="filtersForm.hasError('dateOutOfBounds')">
              Las fechas deben estar dentro del rango del gantt
            </small>
          </div>
        </div>
        <div class="form-group row" *ngIf="machines && machines.length">
          <label class="col-md-3 label-control">Ordenes de montaje</label>
          <div class="col-md-9">
            <ng-select [items]="machines" multiple="true" bindLabel="name" bindValue="id"
              placeholder="Selecciona uno o más máquinas" clearAllText="Clear" formControlName="idMachine"></ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Estado de la tarea</label>
          <div class="col-md-9">
            <ng-select [items]="taskStatusesFilter" multiple="true" bindLabel="label" bindValue="name"
              placeholder="Selecciona uno o más estados" clearAllText="Clear" formControlName="status"></ng-select>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Vista</label>
          <div class="col-md-6">
            <div class="btn-group btn-group-toggle" role="group">
              <label class="btn btn-raised btn-primary" [class.active]="filtersForm.get('view').value === 'IDEAL'">
                <input type="radio" formControlName="view" value="IDEAL" (change)="changeGanttVisibility()" hidden> Teórico
              </label>
              <label class="btn btn-raised btn-primary" [class.active]="filtersForm.get('view').value === 'REAL'">
                <input type="radio" formControlName="view" value="REAL" (change)="changeGanttVisibility()" hidden> Real
              </label>
              <label class="btn btn-raised btn-primary" [class.active]="filtersForm.get('view').value === 'BOTH'">
                <input type="radio" formControlName="view" value="BOTH" (change)="changeGanttVisibility()" hidden> Ambos
              </label>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-3 label-control">Columnas visibles</label>
          <div class="col-md-6">
            <div class="btn-group btn-group-toggle pull-left">
              <mat-slide-toggle class="mr-2"
                                [color]="'primary'"
                                [checked]="showSectorColumn"
                                (change)="changeColumnVisibility('sector')">
                Sector
              </mat-slide-toggle>
              <mat-slide-toggle class=""
                                [color]="'primary'"
                                [checked]="showFlowColumn"
                                (change)="changeColumnVisibility('flow')">
                Flujo
              </mat-slide-toggle>
            </div>
          </div>
        </div>
      </div>
      <div class="form-actions text-right">
        <button class="btn btn-success btn-raised mr-1" type="submit" [disabled]="!filtersForm.valid">Aplicar</button>
        <button class="btn btn-danger btn-raised" type="button" (click)="resetFilters()">Borrar filtros</button>
      </div>
    </form>
  </div>
</aside>
<!-- END Notification Sidebar -->